import React from 'react';
import PropTypes from 'prop-types';

import('./style.scss');

function Checkbox({
  text = '',
  onClick = () => {},
  className = '',
  controlClassName = '',
  labelClassName = '',
  disabled = false,
  checked = false,
  inputName = '',
}) {
  return (
    <label
      htmlFor={inputName}
      className={`tv-checkbox-container ${className} ${
        disabled && 'tv-checkbox-container--disabled'
      }`}
      onClick={onClick}
    >
      <input
        name={inputName}
        disabled={disabled}
        type="checkbox"
        checked={checked}
        onChange={() => {}}
      />
      <span
        className={`fa tv-checkbox-checkmark tv-checkbox__control ${controlClassName}`}
      />
      <div className={`tv-checkbox__label ${labelClassName}`}>{text}</div>
    </label>
  );
}
Checkbox.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  controlClassName: PropTypes.string,
  inputName: PropTypes.string,
};

export default Checkbox;
